export default {
  title: 'SOSAFE para Negocios',
  description:
    '¡Hola! Completa este formulario para que podamos crear el kit de promoción de tu tienda en noticias, comentarios de reportes y en la sección de Mercado SOSAFE.<br/><br/>Por consultas o si tienes más de una tienda, escríbenos a <0>{{contactEmail}}</0>.',
};
